export default {
  loading: 'Завантаження...',
  categories: {
    basic: 'Основні',
    object: 'Об’єкти',
    symbol: 'Символи',
    arrow: 'Стрілки',
    flowchart: 'Блок-схеми',
    animal: 'Тварини',
    game: 'Карти та Шахи',
    dialog_balloon: 'Хмаринки діалогів',
    electronics: 'Електроніка',
    math: 'Математичні',
    music: 'Музика',
    misc: 'Різне',
    raphael_1: 'raphaeljs.com набір 1',
    raphael_2: 'raphaeljs.com набір 2'
  },
  buttons: [
    {
      title: 'Спільна Бібліотека'
    }
  ]
}
